var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgProfessionalActivity = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "47px",
    viewBox: "0 0 40 47",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "28E0C21C-C2E9-44F9-81A9-D8FA8B6D6DEF") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03-Sixtbook_Profile",
    transform: "translate(-460.000000, -3535.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "center",
    transform: "translate(430.000000, 470.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "My-skills",
    transform: "translate(0.000000, 2970.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy",
    transform: "translate(30.000000, 95.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#191919",
    points: "0 0 40 0 40 40 26.1586791 40.1577505 19.9334102 47 13.6959566 40.1496781 0 40"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(10.000000, 4.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.25,17.6221591 L7.05555556,17.6221591 C7.38888889,17.6221591 7.69444444,17.4034091 7.80555556,17.0596591 L8.52777778,15.1221591 L10.7222222,20.9971591 C10.8611111,21.3409091 11.1388889,21.5596591 11.4722222,21.5596591 C11.8055556,21.5596591 12.1111111,21.3409091 12.2222222,20.9971591 L13.5,17.6221591 L14.75,17.6221591 C15.1944444,17.6221591 15.5833333,17.2159091 15.5833333,16.6846591 C15.5833333,16.1846591 15.2222222,15.7471591 14.75,15.7471591 L12.9722222,15.7471591 C12.6388889,15.7471591 12.3333333,15.9659091 12.2222222,16.3096591 L11.5,18.2471591 L9.30555556,12.3721591 C9.05555556,11.6846591 8.05555556,11.6846591 7.80555556,12.3721591 L6.52777778,15.7471591 L5.27777778,15.7471591 C4.83333333,15.7471591 4.44444444,16.1534091 4.44444444,16.6846591 C4.44444444,17.2159091 4.80555556,17.6221591 5.25,17.6221591 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4166667,4.5 L16.1666667,4.5 L16.1666667,6.71875 L17.4444444,6.71875 C17.75,6.71875 17.9722222,7 17.9722222,7.34375 L17.9722222,24.3039773 C17.9722222,24.6477273 17.75,24.9289773 17.4444444,24.9289773 L2.58333333,24.9289773 C2.27777778,24.9289773 2.02777778,24.6477273 2.02777778,24.3039773 L2.02777778,7.34375 C2.02777778,7 2.27777778,6.71875 2.58333333,6.71875 L3.86111111,6.71875 L3.86111111,4.5 L0.611111111,4.5 C0.305555556,4.5 0.0833333333,4.78125 0.0833333333,5.125 L0.0833333333,26.5227273 C0.0833333333,26.8664773 0.333333333,27.1477273 0.611111111,27.1477273 L19.4166667,27.1477273 C19.7222222,27.1477273 19.9444444,26.8664773 19.9444444,26.5227273 L19.9444444,5.125 C19.9444444,4.78125 19.6944444,4.5 19.4166667,4.5 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.02777778,7.53125 L14,7.53125 C14.2777778,7.53125 14.5277778,7.28125 14.5277778,6.9375 L14.5277778,4.15625 C14.5277778,3.84375 14.3055556,3.5625 14,3.5625 L12.0277778,3.5625 L12.0277778,2.4375 C12.0277778,1.1875 11.1111111,0.15625 10,0.15625 C8.88888889,0.15625 7.97222222,1.1875 7.97222222,2.4375 L7.97222222,3.5625 L6,3.5625 C5.72222222,3.5625 5.47222222,3.8125 5.47222222,4.15625 L5.47222222,6.9375 C5.5,7.28125 5.72222222,7.53125 6.02777778,7.53125 Z M10,1.59375 C10.4166667,1.59375 10.75,1.96875 10.75,2.4375 C10.75,2.90625 10.4166667,3.28125 10,3.28125 C9.58333333,3.28125 9.25,2.90625 9.25,2.4375 C9.25,1.96875 9.61111111,1.59375 10,1.59375 Z",
    id: "Shape"
  })))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgProfessionalActivity);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/professional_activity.d14d5579fe993f7c677d0731cd768d1a.svg";